'use strict';

customerZone.run(['$rootScope', '$log', 'Session', 'InvoiceService', 'utils',
    function($rootScope, $log, Session, service, utils){
        $rootScope.$on(Session.PROFILE_CHANGED_EVENT, function(){
            if (Session.authenticated())
                service.getInvoices()
                    .then(function(invoices){
                        showToPayMessage(invoices);
                        setSessionFlag(invoices);
                    })
                    .catch(function(error){
                        $log.error('Could not check pending invoices', error);
                    });
            else utils.hideMessage('invoice-check');

            function showToPayMessage(invoices){
                var profile = Session.profile();
                if (invoices.some(unpaid)){
                    var message = utils.format(utils.finterm('you_have_unpaid_invoices', profile && profile.vat),
                        {'first_name': Session.profile().firstName});
                    utils.showWarn(message, 'invoice-check');
                }
            }

            function setSessionFlag(invoices){
                Session.flags('hasInvoices', !!invoices.length);
            }

            function unpaid(invoice){
                return !invoice.paid;
            }
        });
    }]);
